/**
 * Modyfikatory przeciągania dnd-kit ograniczające ruch do jednej osi.
 *
 * Pakiet `@dnd-kit/modifiers` nie jest zainstalowany, a potrzebujemy tylko dwóch
 * prostych wariantów: nagłówki kolumn przesuwamy w poziomie, listę w panelu „Kolumny"
 * w pionie.
 */

import type { Modifier } from '@dnd-kit/core';

/** Zeruje ruch w pionie — nagłówek kolumny jedzie tylko w lewo/prawo. */
export const restrictToHorizontalAxis: Modifier = ({ transform }) => ({ ...transform, y: 0 });

/** Zeruje ruch w poziomie — wiersz listy jedzie tylko w górę/dół. */
export const restrictToVerticalAxis: Modifier = ({ transform }) => ({ ...transform, x: 0 });
